import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ServicesPage from "../pages/services/page";
import TeamPage from "../pages/team/page";
import PortfolioPage from "../pages/portfolio/page";
import BlogPage from "../pages/blog/page";
import ArticlePage from "../pages/blog/ArticlePage";
import ShopPage from "../pages/shop/page";
import PromotionsPage from "../pages/promotions/page";
import BookingPage from "../pages/booking/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/services", element: <ServicesPage /> },
  { path: "/team", element: <TeamPage /> },
  { path: "/portfolio", element: <PortfolioPage /> },
  { path: "/blog", element: <BlogPage /> },
  { path: "/blog/:id", element: <ArticlePage /> },
  { path: "/shop", element: <ShopPage /> },
  { path: "/promotions", element: <PromotionsPage /> },
  { path: "/booking", element: <BookingPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
